export const mapToServiceFilter = ({
  projectUri,
  client: { id: clientUri } = {},
  programUri,
  availableToBillFilter: {
    clients: clientUris,
    projects: projectUris,
    programs: programUris,
    dateRange: billingPeriod,
    projectManagers: projectLeaderUris
  } = {}
}) => {
  const filter = {
    billingPeriod
  };
  const clientFilter = { clientUris: clientUri ? [clientUri] : clientUris };
  const projectFilter = {
    projectUris: projectUri ? [projectUri] : projectUris
  };
  const programFilter = {
    programUris: programUri ? [programUri] : programUris
  };

  if (clientFilter.clientUris) filter.clientUris = clientFilter.clientUris;
  if (projectFilter.projectUris) filter.projectUris = projectFilter.projectUris;
  if (projectLeaderUris) filter.projectLeaderUris = projectLeaderUris;
  if (programFilter.programUris) filter.programUris = programFilter.programUris;
  filter.excludeZeroAmount = true;

  return filter;
};
